<template>
  <div class="loading-view">
    <div class="loading-view__container">
      <v-progress-linear color="primary" class="my-0 mx-0" indeterminate />

      <div class="loading-view__container__message">
        <span>{{ t("loadingPage") }} <span class="dot">.</span></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { createTranslationModule } from "@/plugins/i18n"
import { defineComponent } from "@vue/composition-api"

export default defineComponent({
  name: "LoadingView",
  setup() {
    const t = createTranslationModule("common")

    return {
      t
    }
  }
})
</script>
